module.exports = __webpack_public_path__ + "images/kia_smallde6f5be3bd7d6727e26b872c75cd5be3.png";